<template lang="pug">
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  item-value='id'
  @input='$emit("input", $event)'
  @change='$emit("change", $event)'
  :items='list'
)
  template(v-slot:selection="{ item }")
    img(:src="item.icon_url" width="20" height="20" style="object-fit: contain")
    div(style="margin-left: 10px") {{ item.name }}
  template(v-slot:item="{ item }")
    img(:src="item.icon_url" width="20" height="20" style="object-fit: contain")
    div(style="margin-left: 10px") {{ item.name }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import picker from '@/mixins/picker'

export default {
  mixins: [picker],

  props: {
    complexId: null,
    label: {
      default: 'Выберите тип метки'
    }
  },

  created() {
    this.fetch({ complex_id: this.complexId })
  },

  methods: mapActions('dictionary/genplanMarkTypes', ['fetch']),
  computed: mapGetters('dictionary/genplanMarkTypes', ['list'])
}
</script>
